<div [formGroup]="form">
  <app-radio-button-list>
    <app-radio-button-list-item [control]="form.get('paymentMethod')" [value]="PaymentMethod.PayWithSubscription">
      <div class="option-container">
        <span class="option-title">Betal nå med abonnement</span>
        @if (selectedSubscription) {
          <span>
            {{
              selectedSubscription.hardwareOfferingPriceWithSubscription.amountIncludingVAT | priceFormat: PriceType.OneTime
            }}
          </span>
        } @else {
          <span>fra {{ accessoryItem.priceFrom | priceFormat: PriceType.OneTime }}</span>
        }
      </div>
      @if (form.get('paymentMethod').value === PaymentMethod.PayWithSubscription) {
        <div class="subscription-chooser">
          <div class="choose-subscription-label">Velg abonnement</div>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-select formControlName="subscription" ngDefaultControl (selectionChange)="onSubscriptionChange()">
              <mat-select-trigger>
                <div class="subscription-option">
                  <span class="option-title">
                    {{ selectedSubscription?.subscriptionFullName }}
                  </span>
                  <span class="option-price selected">
                    {{ selectedSubscription?.subscriptionMonthlyPrice.amountIncludingVAT | priceFormat: PriceType.Monthly }}
                  </span>
                </div>
              </mat-select-trigger>
              <div class="ice-custom-mat-options">
                @for (subscription of availableSubscriptions; track subscription.subscriptionOfferingId) {
                  <mat-option [value]="subscription.subscriptionOfferingId">
                    <div class="subscription-option">
                      <span class="bundle-information">
                        <div class="option-title">
                          {{ subscription.subscriptionFullName }}
                        </div>
                        <div class="discount-info">
                          {{ bindingDiscount(subscription) }}
                        </div>
                      </span>
                      <span class="bundle-information">
                        <div class="option-price">
                          {{ subscription.subscriptionMonthlyPrice.amountIncludingVAT | priceFormat: PriceType.Monthly }}
                        </div>
                        <div class="discount-info">
                          tilb. pris
                          {{
                            subscription.hardwareOfferingPriceWithSubscription.amountIncludingVAT
                              | priceFormat: PriceType.OneTime
                          }}
                        </div>
                      </span>
                    </div>
                  </mat-option>
                }
              </div>
            </mat-select>
          </mat-form-field>
          @if (selectedSubscription) {
            <div class="subscription-details">
              <div class="binding-discount">
                <mat-icon class="invoice-icon" [svgIcon]="IconNames.ice_invoicing" />
                {{ calculatedDiscountPrice | priceFormat: PriceType.OneTime }}
                i bindingsrabatt
              </div>
              <div class="price-info">
                Minste totalpris: {{ minimumTotalPrice | priceFormat: PriceType.OneTime }}
                <br />
                Inkludert tilbehør og abonnement
              </div>
              <app-ice-alert type="info">
                Vipps, kort eller Klarna. Ønsker kunden delbetaling kan du beregne månedskostnader i
                <a
                  class="klarna-calculator-link"
                  data-testid="klarna-calculator-link"
                  href="https://x.klarnacdn.net/hpp/calculator/v1/index.html?country=no"
                  target="_blank"
                >
                  Klarna sin kalkulator
                  <mat-icon>open_in_new</mat-icon>
                </a>
              </app-ice-alert>
              @if (getVasProduct(); as vasProduct) {
                <app-vas-information [vasProduct]="vasProduct" />
              }
            </div>
          }
        </div>
      }
    </app-radio-button-list-item>
    <app-radio-button-list-item [control]="form.get('paymentMethod')" [value]="PaymentMethod.PayNow">
      <div class="option-container">
        <span class="option-title">Betal nå uten abonnement</span>
        <span>
          {{ accessoryItem.priceInformation.price.includingVAT | priceFormat: PriceType.OneTime }}
        </span>
      </div>
    </app-radio-button-list-item>
  </app-radio-button-list>
</div>
